import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { ProviderData } from '@k12/models';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'lib-personal-information',
  standalone: true,
  imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule, NgxMaskDirective],
  providers: [provideNgxMask()],
  templateUrl: './personal-information.component.html'
})
export class PersonalInformationComponent {
  @Input() formGroup!: FormGroup;
  @Input() providerData: ProviderData;
  @Input() providerType: string = '';
  @Input() showReviewStatus: boolean = false;
}
